<template>
	<div>
        <v-empty-state v-if="notification.length < 1" description="You have not yet received any notification!" icon="mdi-comment-account-outline" title="No Notification"></v-empty-state>
        <v-expansion-panel class="elevation-1" v-else>
            <v-expansion-panel-content v-for="(note, index) in notification" :key="index">
                <div slot="header">
                    <h4 class="font-weight-medium subheading text-truncate"><v-icon :color="note.read ? '' : 'primary'" class="mr-2" >mdi-bell-circle-outline</v-icon> New Message Notification</h4>
                    <span class="caption ml-5"><v-icon size="14">mdi-clock-check-outline</v-icon> {{timeManager(note.createdOn)}}</span>
                </div>
                <v-card class="px-2">
                    <v-card-text class="px-3 body-1">
                        "{{note.message}}"
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>   
    </div>
</template>

<script>
import VEmptyState from "./VEmptyState.vue";
export default {
    components: {VEmptyState},
    data() {
        return {
            notification: [],
        }
    },
    methods: {
        timeManager(timeStamp) {
            var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
            var currentDate = new Date().toLocaleDateString("en-US", options)
            var date = new Date(timeStamp).toLocaleDateString("en-US", options)
            var time = new Date(timeStamp).toLocaleTimeString("en-US")

            if (currentDate == date) {
                return time
            } else {
                return date
            }
        }
    }
};
</script>